import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { media } from '@minecraft.themes';

export const StyledCarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  ${media.sm`
    flex-grow: 0;
  `}
`;

export const ButtonWrapper = styled.div`
  margin: auto;
`;

export const StyledCarousel = styled(Carousel)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  .carousel-slider {
    flex-grow: 1;
  }

  .slide {
    background-color: ${(props): string => props.theme.colors.primary.white};
  }

  .slide {
    background-color: ${(props): string => props.theme.colors.primary.white};
  }

  .control-dots {
    padding: 0;

    .dot {
      background-color: ${(props): string => props.theme.colors.primary.ltGrey1};
    }
    .dot.selected {
      background-color: ${(props): string => props.theme.colors.primary.grey1};
    }
  }
`;
